import * as actionTypes from '../constants/actionType';
import initialState from './initialState';

export default function NewsReducer(state = initialState.news, action) {
  switch (action.type) {
    case actionTypes.NEWS_LOAD_START:
      return {
        ...state,
        isLoading: true
      };

    case actionTypes.NEWS_LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case actionTypes.NEWS_LOAD_SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoading: false,
        error: undefined
      };
    }

    default:
      return state;
  }
}
